import { useMemo } from 'react';

import { PropertyHeader } from '../../../components/PropertyHeader/PropertyHeader.tsx';

export const useHeaderByID = () =>
  useMemo(
    () =>
      ({ id }: { id: string }) => <PropertyHeader propertyId={id} />,
    [],
  );
